<template>
  <div id="app">
    <keep-alive >
      <router-view class="view_wrap" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view class="view_wrap" v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
import TabBar from './components/tabBar.vue';

export default {
  components: {
    TabBar,
  },
  beforeDestroy() {
    console.log('应用销毁前调用cancelAlarm');

    // 在应用销毁前调用
    if (window.CSDK && typeof window.CSDK.cancelAlarm === 'function') {
      window.CSDK.cancelAlarm();
    }
  },
  deactivated() {
    console.log('应用失活时');

    // 在应用失活时调用
    // if (window.CSDK && typeof window.CSDK.cancelAlarm === 'function') {
    //   window.CSDK.cancelAlarm();
    // }
  }
};
</script>
<style>

#old,#new{
  margin-top: 50px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  font-size: .88rem;
}
  html,body,#app{
    height: 100%;
  }
/* 样式重置 */
body,h1,h2,h3,h4,h5,h6,hr,p,ul,ol,dl,dd,fieldset,input,option,textarea,td,figure{
	margin:0;
	padding:0;
}
body{
	font-family: "微软雅黑";
}
a{
	text-decoration: none;
}
ul,li{
	list-style: none;
}
img{
	border: none;
}

@font-face {font-family: "iconfont";
  src: url('//at.alicdn.com/t/font_1606151_pyrsjq6lcad.eot?t=1578565513782'); /* IE9 */
  src: url('//at.alicdn.com/t/font_1606151_pyrsjq6lcad.eot?t=1578565513782#iefix') format('embedded-opentype'), /* IE6-IE8 */
  url('data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAAAL4AAsAAAAABsgAAAKsAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCCfgqBIIEgATYCJAMMCwgABCAFhG0HTxv3BcgusG3kM03IhW696a5/hHEv8I4QiyDa73X27kJIEso6KraEKsLkV1axEWREja8jsK2it/9Ll45pVJ7vllVrqhawN/Pvdm4ti9MohZAgHAxd8yvpWyTK3h64V6EVeLh/XZXufBOawLoD8PcZbMABBhzyALrYQv/P5fSmjyyaHyintbYNP+oFGAcU4JibrEBCT2F41UHuxGYCzcZNtC5cerzBUGH3CsSDu4YCw0JMUcRio1DfMLGIJ0iN6VH6AY+j78dPq2gkqcvsrY5uHXXYfMEv5lqlegbAfB6I08hYBQpx3Jg70hEip6M51zUL9tUq+DJVVXyZDBxir9xE/HVuaStYpPnEl0lP59bkdIoEMqgvFlaBXUb2PilEf3/v+FFiGryp3gb14qW8ay6Hi8Nz1a+aUKeXJUSbH6MdW6qhfH8T/39yc1dkuATzq4P+dI3R3r/li8j/eIuI1ChO9b468ZNt20NkgOo0mbkGqWqZyA9/4m9c+8UuE/5ubCng3f7kNopUpwXBAojG0/iDXyYHq4qhtO25aDJPZgWyfsCToBIpqGKHuv2ON/TBlYRGfSMCDcYyyBrNooVchTotdqFeo0NotuI8vUWPSEeUJiz7JBA6fUHS7i1knb7RQv5AnX5/UK8zMjQ7DmnBFvNxtzk6ISUhHdUNWj32hetMxnH5k4zUVaK8MuJ9UBRbSVyadrl4Jp+iOYbES2OVzAWKKXt4ItuR6zIGU7ZJS2bmPAnWc2vY9KaZNvJg7LwIUSSIDqlKyKJhPhHUT4wrn38ihpRLEXWw6uIfSCRmNY+WZhYAetb5EOterollDCuJhICECPOgE/EQ18kxFDS3sxFNYsYckQmszVktgepm6xu879sAzewjcqTIUXRtBm6vw1XKkm0pvlGkFdJjYpOsAA==') format('woff2'),
  url('//at.alicdn.com/t/font_1606151_pyrsjq6lcad.woff?t=1578565513782') format('woff'),
  url('//at.alicdn.com/t/font_1606151_pyrsjq6lcad.ttf?t=1578565513782') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */
  url('//at.alicdn.com/t/font_1606151_pyrsjq6lcad.svg?t=1578565513782#iconfont') format('svg'); /* iOS 4.1- */
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-052caozuo_jiangxu:before {
  content: "\e620";
}

.icon-053caozuo_shengxu:before {
  content: "\e621";
}
</style>
<style scoped>
.tablist{
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  height:50px;
  background-color:#fff;
  border-top: 1px solid #ececec;
}
.tablist>li{
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.tablist>li>img{
  width: 20px;
  height: 20px;
}
/deep/ .van-submit-bar{
  box-shadow: 0 -.01rem 1rem .001rem #e1e1e1;
  height: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.van-submit-bar__bar{
  width: 100%;
}
/deep/ .van-submit-bar__button--danger{
  background-image: linear-gradient(90deg, #FF9F22, #FFB600);
  height: 2.8rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue